import React from "react";

const Header = () => {
  return (
    <header>
      <div className="container">
        <div className="header-content">
          <div className="logo">Ceekay Enterprise</div>
          <div className="company-info">
            <div>📍 Mumbai, Maharashtra | 📞 Contact: +91-9322629818 | GST: 27AAAPP8389F1ZA</div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
